import {
    SET_SHIPPING_DATA,
    SET_PICKUP_VALUE,
    SET_SHIPPING_VALUE,
    SET_SHIPPING_COST,
    SET_SHIPPING_ERROR,
    SET_SHIPPING_STATUS,
} from '../costants/ActionTypes'

const initialState = {
    map_type: "yandex",
    key: "",
    status: "NOT_LOADED",
    method: "pickup",
    variant: 1,
    variants: {
        pickup: {
            method_title: "САМОВЫВОЗ СО СКЛАДА",
            method_icon: "home",
            value: 1,
            title: "Самовывоз: г. Белгород, ул. Чичерина 1м",
            total: "0.0",
            calculated: true,
            variants: [
                {id: 1, name: "г. Белгород, ул. Чичерина 1м", title: "Самовывоз: г. Белгород, ул. Чичерина 1м", total: "0.0"},
                {id: 2, name: "г. Старый Оскол, ул. Мира 10А", title: "Самовывоз: Старый Оскол, ул. Мира 10А", total: "0.0"}
            ],
        },
        shipping:{
            method_title: "ДОСТАВКА КУРЬЕРСКОЙ СЛУЖБОЙ",
            method_icon: "local_shipping",
            value: "Адрес предшествующего заказа",
            title: "Доставка: Адрес предшествующего заказа",
            total: "0.0",
            delivery_days: 0,
            delivery: "",
            calculated: false,
            map: {},
            variants: [],
            variant: 0
        }
    }
}


const nshipping = (state = initialState, action) => {

  switch (action.type) {

      case SET_SHIPPING_DATA:

          return Object.assign({}, state, action.data)

      case SET_PICKUP_VALUE:

          let pickup = Object.assign({}, state.variants.pickup, {
              variant: action.data.id,
              value: action.data.name,
              total: action.data.total,
              title: action.data.title
          });

          let pickup_res = Object.assign({}, state, {
              method: "pickup",
              variant: action.data.id,
              variants: {
                  pickup: pickup,
                  shipping: Object.assign({}, state.variants.shipping)
              }
          });

          return pickup_res

      case SET_SHIPPING_VALUE:

          let shipping = Object.assign({}, state.variants.shipping, {
              variant: action.data.id,
              total: action.data.price,
              title: action.data.title,
              calculated: action.data.calculated!==undefined ? action.data.calculated : state.variants.shipping.calculated,
              delivery: action.data.delivery!==undefined ? action.data.delivery : state.variants.shipping.delivery
          });

          let shipping_res = Object.assign({}, state, {
              method: "shipping",
              variant: action.data.id,
              variants: {
                  pickup: Object.assign({}, state.variants.pickup),
                  shipping: shipping
              }
          });


          return shipping_res

      case SET_SHIPPING_COST:

          const sres = Object.assign({}, state, {
              method: "shipping",
              variant: action.data.variant,
              variants: {
                  pickup: Object.assign({}, state.variants.pickup),
                  shipping: Object.assign({}, state.variants.shipping, action.data)
              }
          });

          return sres


      case SET_SHIPPING_ERROR:

          let shipping_err = Object.assign({}, state.variants.shipping, {
              variant: 0,
              total: "0.0",
              title: "Стоимость доставки не расчитана, уточните адрес доставки",
              map: {},
              delivery: "",
              calculated: false,
          });

          const eres = Object.assign({}, state, {
              method: "shipping",
              variant: 0,
              variants: {
                  pickup: Object.assign({}, state.variants.pickup),
                  shipping: shipping_err
              }
          });

          return eres

      case SET_SHIPPING_STATUS:
          return Object.assign({}, state, {
              status: action.status
          })

      default:
        return state

  }

}

export default nshipping